import { hasAnyRole, readCurrentUserRoleKeys, type CurrentUserRoleSource } from "./lib/session";
import { ADMIN_PERMISSION_MATRIX, type AdminAccessKey } from "./lib/access-policy";

type InitialState = {
  currentUser?: CurrentUserRoleSource | null;
};

export default function access(initialState: InitialState | undefined) {
  const currentUser = initialState?.currentUser;
  const roleKeys = readCurrentUserRoleKeys(currentUser);
  return ADMIN_PERMISSION_MATRIX.reduce<Record<AdminAccessKey, boolean>>(
    (result, item) => {
      result[item.key] = hasAnyRole(roleKeys, item.roles);
      return result;
    },
    {} as Record<AdminAccessKey, boolean>,
  );
}
